import { __cProductService } from '@/services/client/__c.product.service'
import { SizeCalculationMaleParams, TCalculateSizeParams } from '@/types/size'
import { useMutation, useQuery } from '@tanstack/react-query'

export function useProductSizeMaleSuggestion(
  sizeData: SizeCalculationMaleParams
) {
  return useQuery({
    queryKey: ['product-size-suggestion', sizeData],
    queryFn: () => __cProductService.getSizeMaleSuggestion(sizeData),
    enabled: !!sizeData,
  })
}

export function useSizeTableBySlug(slug: string) {
  return useQuery({
    queryKey: ['size-table-by-slug', slug],
    queryFn: () => __cProductService.getSizeTableBySlug(slug),
    enabled: !!slug,
  })
}

export const useCalculateSizeMutation = () => {
  return useMutation({
    mutationKey: ['mutation.calculate-size'],
    mutationFn: (params: TCalculateSizeParams) =>
      __cProductService.getProductSizeSuggestion(params),
  })
}

export const useCalculateManSizeMutation = () => {
  return useMutation({
    mutationKey: ['mutation.calculate-man-size'],
    mutationFn: (params: SizeCalculationMaleParams) =>
      __cProductService.getProductMenSizeSuggestion(params),
  })
}
